import { FunnelImage, ScreenBackground } from '../Content';
import { BaseScreenAttributes } from './BaseScreenAttributes';
import { ScreenType } from './ScreenType';

export enum LayoutVariant {
  DEFAULT = 'default',
  HORIZONTAL = 'horizontal',
  IMAGE = 'image',
  SQUARE = 'square',
}

export type BaseAnswer = { text: string; value: string };
export type EmojiAnswer = BaseAnswer & { emoji?: string };
export type BgImageAnswer = BaseAnswer & { bgImage: FunnelImage };
export type ImageAnswer = BaseAnswer & { image: FunnelImage };

export type VariantAnswers =
  | { variant: LayoutVariant.DEFAULT; answers: Array<EmojiAnswer> }
  | { variant: LayoutVariant.HORIZONTAL; answers: Array<EmojiAnswer> }
  | { variant: LayoutVariant.IMAGE; answers: Array<BgImageAnswer> }
  | { variant: LayoutVariant.SQUARE; answers: Array<ImageAnswer> };

type SharedContent = {
  title: string;
  titleImage?: FunnelImage;
  subtitle?: string;
  image?: FunnelImage;
  maxSelectCount?: number;
  next: string;
  backgroundImage?: ScreenBackground;
};

export interface MultipleAnswersV2ScreenAttributes extends BaseScreenAttributes {
  dataKey: string;
  content: SharedContent & VariantAnswers;
  screenType: ScreenType.MULTIPLE_ANSWERS_V2;
}
